import type { RecoverSession } from '@/shared/domain'

let inFlightRecovery: Promise<string | null> | null = null

export function recoverSessionOnce(recover: RecoverSession): Promise<string | null> {
  if (inFlightRecovery) return inFlightRecovery
  inFlightRecovery = recover().finally(() => {
    inFlightRecovery = null
  })
  return inFlightRecovery
}

export function clearSessionRecovery(): void {
  inFlightRecovery = null
}
